<script>
	import { getContext } from 'svelte'
	import { styles } from '../library/scripts/styles'
	import { storeRoomConfirm, storeShowRoomDetail, storeShowRooms } from '../library/scripts/Store.svelte'
	import { validate } from '../library/scripts/validate'
	import { admin } from '../library/scripts/PhpHandler.svelte'
	import TwoCols from '../library/columLayouts/TwoCols.svelte'
	import Spinner from '../library/ShadersAndSpinners/SpinnerCircle.svelte'
	import Shader from '../library/ShadersAndSpinners/Shader.svelte'
	import Alert from '../modals/Alert.svelte'

	const globals = getContext('globals')
	const fsButton = globals.fsS
	const buttonColor = globals.buttonColor
	const buttonHover = globals.buttonHover
	const inputBg = globals.inputBg
	const inputFocus = globals.inputFocus
	const fsInput = globals.fsN
	const colorMain = globals.colorMain
	const fsTitle = globals.fsN
	const fsLabel = globals.fsN
	const fsError = globals.fsN
	const fsSuccess = globals.fsN
	const colorError = globals.colorError
	const colorSuccess = globals.colorOk

	//the booking details
	const booking = JSON.parse(sessionStorage.getItem('booking'))

	//bindings
	let name = ''
	let phone = ''
	let mail = ''
	let specials = ''
	let guests = 1
	let arrivalTime = '12:00- 14:00'

	//error handling
	let errorOffline = false
	let errorName = false
	let errorPhone = false
	let errorMail = false
	let errorMessage = ''

	//sending
	let send = false
	let answer = false

	const reset_error = () => {
		errorOffline = false
		errorMessage = ''
	}

	const book_room = async () => {
		const vName = validate('input', name)
		if (!vName) {
			errorName = true
			errorMessage = 'please enter your name'
			const toError = setTimeout(() => {
				errorName = false
				errorMessage = ''
				clearTimeout(toError)
			}, 2000)

			return
		}

		const vPhone = validate('phone', phone)
		if (!vPhone) {
			errorPhone = true
			errorMessage = 'please enter a valid phone-number'
			const toError = setTimeout(() => {
				errorPhone = false
				errorMessage = ''
				clearTimeout(toError)
			}, 2000)

			return
		}

		const vMail = validate('email', mail)
		if (!vMail) {
			errorMail = true
			errorMessage = 'please enter a valid email-address'
			const toError = setTimeout(() => {
				errorMail = false
				errorMessage = ''
				clearTimeout(toError)
			}, 2000)

			return
		}

		//the send object
		const sendBooking = {
			name: name,
			phone: phone,
			specials: specials,
			email: mail,
			guests: guests,
			room: booking.room,
			checkin: booking.checkin,
			checkout: booking.checkout,
			days: booking.totalDays,
			total: booking.total,
			currency: booking.currency,
			breakfast: booking.breakfast,
			arrival: arrivalTime,
			low: booking.low,
			high: booking.high,
		}

		send = true
		const sendBook = await admin({ cmd: 'make_booking', data: sendBooking })
		if (sendBook) {
			send = false
			answer = true
			const toResponse = setTimeout(() => {
				answer = false
				storeRoomConfirm.set(false)
				storeShowRoomDetail.set(false)
				storeShowRooms.set(false)
				clearTimeout(toResponse)
			}, 8000)
		}
	}

	const close_window = () => {
		storeRoomConfirm.set(false)
	}
</script>

<TwoCols column="250px" alignVertical="flex-start" width="100vw" padding="5%" scroll="scroll">
	<div slot="column1" class="column1">
		{#if !send && !answer}
			<div class="title" use:styles={{ fsTitle, colorMain }}>Personal Details</div>
			<div class="label" use:styles={{ fsLabel, colorMain }}>Name</div>
			{#if errorName}
				<div class="error" use:styles={{ colorError, fsError }}>{errorMessage}</div>
			{:else}
				<input
					type="text"
					use:styles={{ fsInput, inputBg, inputFocus, colorMain }}
					bind:value={name}
					placeholder="name"
				/>
			{/if}

			<div class="label" use:styles={{ fsLabel, colorMain }}>Phone</div>
			{#if errorPhone}
				<div class="error" use:styles={{ colorError, fsError }}>{errorMessage}</div>
			{:else}
				<input
					type="text"
					use:styles={{ fsInput, inputBg, inputFocus, colorMain }}
					bind:value={phone}
					placeholder="phone"
				/>
			{/if}

			<div class="label" use:styles={{ fsLabel, colorMain }}>Email Address</div>
			{#if errorMail}
				<div class="error" use:styles={{ colorError, fsError }}>{errorMessage}</div>
			{:else}
				<input
					type="text"
					use:styles={{ fsInput, inputBg, inputFocus, colorMain }}
					bind:value={mail}
					placeholder="email address"
				/>
			{/if}

			<div class="label" use:styles={{ fsLabel, colorMain }}>Guests</div>
			<input
				type="number"
				use:styles={{ fsInput, inputBg, inputFocus, colorMain }}
				min="1"
				max={booking.guests}
				bind:value={guests}
			/>

			<div class="label" use:styles={{ fsLabel, colorMain }}>Arrival Time</div>
			<select bind:value={arrivalTime} use:styles={{ fsInput, inputBg, inputFocus, colorMain }}>
				<option selected={arrivalTime}>{arrivalTime}</option>
				<option value="00:00 - 02:00">00:00 - 02:00</option>
				<option value="02:00 - 04:00">02:00 - 04:00</option>
				<option value="04:00 - 06:00">04:00 - 06:00</option>
				<option value="06:00 - 08:00">06:00 - 08:00</option>
				<option value="08:00 - 10:00">08:00 - 10:00</option>
				<option value="10:00 - 12:00">10:00 - 12:00</option>
				<option value="12:00 - 14:00">12:00 - 14:00</option>
				<option value="14:00 - 16:00">14:00 - 16:00</option>
				<option value="16:00 - 18:00">16:00 - 18:00</option>
				<option value="18:00 - 20:00">18:00 - 20:00</option>
				<option value="20:00 - 22:00">20:00 - 22:00</option>
				<option value="22:00 - 00:00">22:00 - 00:00</option>
			</select>

			<div class="label" use:styles={{ fsLabel, colorMain }}>Specials/Message</div>
			<textarea use:styles={{ fsInput, inputBg, inputFocus, colorMain }} bind:value={specials} />
		{:else if send && !answer}
			<div class="spinner">
				<Spinner color="hsl(0,0%,70%)" info="send booking" size="50px" fontSize={fsLabel} width="100%" />
			</div>
		{:else if !send && answer}
			<div class="success" use:styles={{ fsSuccess, colorSuccess }}>
				<div>Dear {name}</div>
				<div>Thank you for your trust in our hospitality!</div>
				<div>We are looking forward to welcome you on the</div>
				<div>{booking.checkin}</div>
			</div>
		{/if}
	</div>

	<div slot="column2" class="column2">
		<div class="title_right" use:styles={{ fsTitle, colorMain }}>Booking Details</div>
		<div class="column_row">
			<div class="label" use:styles={{ fsLabel, colorMain }}>Room</div>
			<div class="label" use:styles={{ fsLabel, colorMain }}>{booking.room}</div>
		</div>

		<div class="column_row">
			<div class="label" use:styles={{ fsLabel, colorMain }}>Sleeps</div>
			<div class="label" use:styles={{ fsLabel, colorMain }}>{booking.guests}</div>
		</div>

		<div class="column_row">
			<div class="label" use:styles={{ fsLabel, colorMain }}>Breakfast</div>
			<div class="label" use:styles={{ fsLabel, colorMain }}>
				{booking.breakfast}
			</div>
		</div>

		<div class="column_row">
			<div class="label" use:styles={{ fsLabel, colorMain }}>Dates</div>
			<div class="label" use:styles={{ fsLabel, colorMain }}>{booking.checkin} - {booking.checkout}</div>
		</div>
		<div class="column_row">
			<div class="label" use:styles={{ fsLabel, colorMain }}>Days</div>
			<div class="label" use:styles={{ fsLabel, colorMain }}>{booking.totalDays}</div>
		</div>
		<div class="column_row">
			<div class="label" use:styles={{ fsLabel, colorMain }}>TOTAL</div>
			<div class="label price" use:styles={{ fsLabel, colorMain }}>{booking.currency} {booking.total}</div>
		</div>

		<div class="column_row">
			<div class="label" use:styles={{ fsLabel, colorMain }}>Name</div>
			<div class="label" use:styles={{ fsLabel, colorMain }}>{name}</div>
		</div>

		<div class="column_row">
			<div class="label" use:styles={{ fsLabel, colorMain }}>Phone</div>
			<div class="label" use:styles={{ fsLabel, colorMain }}>{phone}</div>
		</div>

		<div class="column_row">
			<div class="label" use:styles={{ fsLabel, colorMain }}>Email</div>
			<div class="label" use:styles={{ fsLabel, colorMain }}>{mail}</div>
		</div>

		<div class="column_row">
			<div class="label" use:styles={{ fsLabel, colorMain }}>Guests</div>
			<div class="label" use:styles={{ fsLabel, colorMain }}>{guests}</div>
		</div>

		<div class="column_row">
			<div class="label" use:styles={{ fsLabel, colorMain }}>Arrival Time</div>
			<div class="label" use:styles={{ fsLabel, colorMain }}>{arrivalTime}</div>
		</div>

		<div class="column_row">
			<div class="label" use:styles={{ fsLabel, colorMain }}>Message</div>
			<div class="label" use:styles={{ fsLabel, colorMain }}>{specials}</div>
		</div>

		<div class="button_container">
			<button on:click={book_room} use:styles={{ fsButton, buttonColor, buttonHover }}>book</button>
			<button on:click={close_window} use:styles={{ fsButton, buttonColor, buttonHover }}>cancel</button>
		</div>
	</div>
</TwoCols>

{#if errorOffline}
	<Shader>
		<div slot="content">
			<Alert message={errorMessage} showOkButton={false} alertMessage="ERROR" on:alertclose={reset_error} />
		</div>
	</Shader>
{/if}

<style>
	.label {
		color: var(--colorMain);
		font-size: var(--fsLabel);
		margin-bottom: 10px;
	}

	input[type='text'] {
		outline: none;
		font-size: var(--fsInput);
		color: var(--colorMain);
		background-color: var(--inputBg);
		width: 85%;
		margin-bottom: 20px;
	}

	input[type='number'] {
		width: 150px;
		font-size: var(--fsInput);
		background-color: var(--inputBg);
		color: var(--colorMain);
		outline: none;
	}

	input[type='text']:focus {
		background-color: var(--inputFocus);
	}

	textarea {
		outline: none;
		font-size: var(--fsInput);
		color: var(--colorMain);
		background-color: var(--inputBg);
		width: 85%;
		margin-bottom: 20px;
	}

	select {
		outline: none;
		font-size: var(--fsInput);
		color: var(--colorMain);
		background-color: var(--inputBg);
		width: 85%;
		margin-bottom: 20px;
	}
	.column1 {
		display: flex;
		flex-direction: column;
		justify-content: flex-start;
		align-items: flex-start;
		height: 100%;
		width: 100%;
		border: 1px solid lightgrey;
		padding: 20px;
	}

	.column2 {
		display: flex;
		flex-direction: column;
		justify-content: flex-start;
		align-items: flex-start;
		height: 100%;
		width: 100%;
		border: 1px solid lightgrey;
		padding: 20px;
	}

	.column_row {
		display: grid;
		width: 100%;
		grid-template-columns: 30% 60%;
		margin-bottom: 20px;
	}

	.button_container {
		display: flex;
		width: 100%;
		justify-content: flex-end;
		margin-top: 20px;
	}

	button {
		display: flex;
		justify-content: center;
		align-items: center;
		margin-left: 20px;
		background-color: transparent;
		font-size: var(--fsButton);
		color: var(--buttonColor);
		border: 1px solid white;
		border-radius: 10px;
		cursor: pointer;
		width: 100px;
		height: 30px;
	}

	button:hover {
		background-color: var(--buttonHover);
	}

	.title {
		display: flex;
		width: 100%;
		justify-content: center;
		margin-bottom: 20px;
		font-size: var(--fsTitle);
		font-weight: bold;
		font-style: italic;
		text-decoration: underline;
	}

	.title_right {
		display: flex;
		width: 100%;
		justify-content: flex-start;
		margin-bottom: 20px;
		font-size: var(--fsTitle);
		font-weight: bold;
		font-style: italic;
		text-decoration: underline;
	}

	.price {
		font-weight: bold;
	}

	.spinner {
		width: 100%;
		height: 100%;
		display: flex;
		justify-content: center;
		align-items: center;
	}

	.error {
		font-size: var(--fsError);
		color: var(--colorError);
	}

	.success {
		width: 100%;
		height: 100%;
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		font-size: var(--fsSuccess);
		color: var(--colorSuccess);
	}
</style>
